/* eslint-disable no-unused-vars */
import * as React from 'react';
import TableCell from '@material-ui/core/TableCell';
import PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import {withStyles} from "@material-ui/styles";
import Modal from "@material-ui/core/Modal";
import moment from "moment";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import * as ApiUtils from "../../util/ApiUtils";
import {GreyButton} from "./ButtonsConstants";
import { t } from '../../i18n';

const top = 50;
const left = 50;

const classes = (theme => ({

    paper: {
        position: 'absolute',
        width: 800,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    },
    root: {
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

class MTableCell2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            isLoading: true,
        };
        this.showModal = this.showModal.bind(this);
        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.fileUploadHandler = this.fileUploadHandler.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    getRenderValue() {
        if (this.props.columnDef.emptyValue !== undefined && (this.props.value === undefined || this.props.value === null)) {
            return this.getEmptyValue(this.props.columnDef.emptyValue);
        }
        if (this.props.columnDef.render) {
            if (this.props.rowData) {
                return this.props.columnDef.render(this.props.rowData, 'row');
            }
            else {
                return this.props.columnDef.render(this.props.value, 'group');
            }

        } else if (this.props.columnDef.type === 'boolean') {
            const style = { textAlign: 'left', verticalAlign: 'middle', width: 48 };
            if (this.props.value) {
                return <this.props.icons.Check style={style} />;
            } else {
                return <this.props.icons.ThirdStateCheck style={style} />;
            }
        } else if (this.props.columnDef.type === 'date') {
            if (this.props.value) {
                return moment(this.props.value).format('DD/MM/YYYY');
            } else {
                return t('common.na');
            }
        } else if (this.props.columnDef.type === 'time') {
            if (this.props.value instanceof Date) {
                return this.props.value.toLocaleTimeString();
            } else {
                return this.props.value;
            }
        } else if (this.props.columnDef.type === 'datetime') {
            if (this.props.value instanceof Date) {
                return this.props.value.toLocaleString();
            } else {
                return this.props.value;
            }
        } else if (this.props.columnDef.type === 'currency') {
            return this.getCurrencyValue(this.props.columnDef.currencySetting, this.props.value);
        } else if (this.props.columnDef.type === 'signature') {
            return (
                <img src={ this.props.value } alt="signature"/>
            );
        }

        return this.props.value;
    }

    getEmptyValue(emptyValue) {
        if (typeof emptyValue === 'function') {
            return this.props.columnDef.emptyValue(this.props.rowData);
        } else {
            return emptyValue;
        }
    }

    getCurrencyValue(currencySetting, value) {
        if (currencySetting !== undefined) {
            return new Intl.NumberFormat((currencySetting.locale !== undefined) ? currencySetting.locale : 'en-US',
                {
                    style: 'currency',
                    currency: (currencySetting.currencyCode !== undefined) ? currencySetting.currencyCode : 'USD',
                    minimumFractionDigits: (currencySetting.minimumFractionDigits !== undefined) ? currencySetting.minimumFractionDigits : 2,
                    maximumFractionDigits: (currencySetting.maximumFractionDigits !== undefined) ? currencySetting.maximumFractionDigits : 2
                }).format((value !== undefined) ? value : 0);
        } else {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((value !== undefined) ? value : 0);
        }
    }

    handleClickCell = e => {
        if (this.props.columnDef.disableClick) {
            e.stopPropagation();
        }
    };

    getStyle = () => {
        let cellStyle = {
            color: 'inherit',
        };

        if (typeof this.props.columnDef.cellStyle === 'function') {
            cellStyle = { ...cellStyle, ...this.props.columnDef.cellStyle(this.props.value, this.props.rowData) };
        } else {
            cellStyle = { ...cellStyle, ...this.props.columnDef.cellStyle };
        }

        if (this.props.columnDef.disableClick) {
            cellStyle.cursor = 'default';
        }

        return { ...this.props.style, ...cellStyle };
    };

    showModal() {
        this.setState({ show: true });
    }

    closeModal() {
        this.setState({
            show: false,
        });
    }

    onChangeHandler = (event) =>{
        let file = event.target.files[0];
        console.log(file);
        /* console.log(this.validateSize(event));
        if(this.validateSize(event)){
            console.log(file);
            // if return true allow to setState
            this.setState({
                selectedFile: file
            });

        }*/
    };

    fileUploadHandler = (rowData) => {
        console.log(this.state.selectedFile);
        this.props.handleFileUpload(rowData.id, this.state.selectedFile);
        this.closeModal();
    };

    render() {

        const { icons, columnDef, rowData, ...cellProps } = this.props;

        return (
            <TableCell
                size={this.props.size}
                {...cellProps}
                style={this.getStyle()}
                align={['numeric','currency'].indexOf(this.props.columnDef.type) !== -1 ? "right" : "left"}
                onClick={this.handleClickCell}
            >
                {(this.props.columnDef.type === 'fileupload') &&
                ((rowData && rowData.fileName) ? <GreyButton onClick={() => ApiUtils.downloadFile(rowData.certificateId)}>{ t('common.download') }</GreyButton> : t('context.common.na'))}
                {this.props.children}
                {this.getRenderValue()}
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.show}
                    onClose={this.closeModal}
                >
                    <div className={this.props.classes.paper}>
                        <form method="post" action="#" id="#">
                            <div className="form-group files">
                                <Typography component="h2" variant="h5">{ t('common.uploadFileTitle') }</Typography>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="file"
                                    name="file"
                                    autoFocus
                                    onChange={ this.onChangeHandler }
                                    type="file"
                                />
                            </div>
                            <div className="col-md-6 pull-right">
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    onClick={() => this.fileUploadHandler(rowData)}
                                >
                                    { t('common.uploadFileButton') }
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal>
            </TableCell>
        );
    }
}

MTableCell2.defaultProps = {
    columnDef: {},
    value: undefined
};

MTableCell2.propTypes = {
    columnDef: PropTypes.object.isRequired,
    value: PropTypes.any,
    rowData: PropTypes.object,
    handleFileUpload: PropTypes.func,
};

export default withStyles(classes)(MTableCell2);